import { Reducer } from 'redux';
import { FuelStop } from "models/FuelStop";
import { IFuelStopActions, FuelStopActionType } from "redux/actions/machines/FuelStopActions";

const initialState: FuelStop[] | null = null;
export const fuelStopsReducer: Reducer<FuelStop[] | null, IFuelStopActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case FuelStopActionType.FETCH_FUELSTOPS_SUCCESS:
                {
                    return action.returnPayload as FuelStop[];
                }
            case FuelStopActionType.ADD_FUELSTOP_SUCCESS:
                {
                    let newFuelStops = [...state!];
                    newFuelStops.push({ ...action.returnPayload } as FuelStop)
                    return newFuelStops;
                }
            case FuelStopActionType.EDIT_FUELSTOP_SUCCESS:
            case FuelStopActionType.DELETE_FUELSTOP_SUCCESS:
                {
                    let newFuelStops = [...state!];
                    const updatedFuelStop = { ...action.returnPayload } as FuelStop;
                    newFuelStops = newFuelStops.map(nm => nm.id === updatedFuelStop.id ? updatedFuelStop : nm);
                    return newFuelStops;
                }
            default:
                return state;
        }
    };
